<template>
    <div class="card mt-5" id="purchase-section" v-if="totalPembeliAllValue">
        <div class="card-body">

            <div class="row pb-4">
                <div class="col-sm-6">
                    <strong style="font-size:20px">Laporan Penjualan</strong>
                </div>
                <div class="col-sm-6 d-flex justify-content-end">
                    <b-button variant="primary" size="sm" class="text-capitalize" @click="download">Download</b-button>
                </div>
            </div>
            <b-row>
                <b-col sm="12" lg="6">
                    <b-row class="align-items-center mb-2">
                        <b-col sm="4" lg="2">
                            <p class="text-capitalize m-0">periode</p>
                        </b-col>
                        <b-col sm="4" lg="4">
                            <b-form-select size="sm" v-model="periodeSelected" :options="filterPeriode"></b-form-select>
                        </b-col>
                        <b-col sm="8" offset-sm="4" offset-lg="2" lg="6" class="mt-2" v-if="selectedPeriodeRange">
                            <DatePickerX v-model="dateRange" is-range
                                :input-props="{ placeholder: 'Pilih Tanggal', readonly: true }"
                                :masks="{ input: 'DD-MM-YYYY' }" :max-date="maxDate" :min-date="minDate">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <div class="flex justify-center items-center">
                                        <template v-if="dateRange">
                                            <input readonly :value="inputValue.start + ' - ' + inputValue.end"
                                                v-on="inputEvents.start"
                                                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300" />
                                        </template>
                                        <template v-else>
                                            <input readonly placeholder="Pilih Tanggal" v-on="inputEvents.start"
                                                class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300" />
                                        </template>
                                    </div>
                                </template>
                            </DatePickerX>
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col sm="12">
                            <small class="font-italic" style="color: red">
                                *Data yang ditampilkan maksimal 3 bulan terakhir
                            </small>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col sm="12" lg="6">
                    <b-row class="mb-2">
                        <b-col sm="4" lg="7" class="text-right-lg">PERIODE</b-col>
                        <b-col sm="8" lg="5">
                            <b-form-input class="text-right" size="sm" disabled
                                :value="periodeX({ periode: periodeSelected, rawValue: true })" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col sm="4" lg="7" class="text-right-lg">TOTAL PEMBELI</b-col>
                        <b-col sm="8" lg="5">
                            <b-form-input class="text-right" size="sm" disabled
                                :value="totalPembeliValue == '0' || !totalPembeliValue ? '0' : totalPembeliValue + ' Orang'" />
                        </b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col sm="4" lg="7" class="text-right-lg">TOTAL PENJUALAN</b-col>
                        <b-col sm="8" lg="5">
                            <b-form-input class="text-right" size="sm" disabled :value="totalPendapatanValue" />
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <DataTableWrapper
                id="laporan-penjualan-wrapper"
                :perPage="perPage"
                :currentPage="currentPage"
                :customPagingClass="['custom-pagination']"
                :customEntryOptions="{ f: customEntryOptions }"
                dropdownSizeProps="sm"
                :rows="rows"
                :fromPage="fromPage"
                :toPage="toPage"
                @pageChanged="handleValueChanged"
            >
                <b-table
                    id="laporan-penjualan-table"
                    :items="dataList"
                    :fields="fieldList"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :no-local-sorting="true"
                    :responsive="true"
                    :sticky-header="true"
                >
                    <template v-slot:cell()="data">
                        <template v-if="
                            data.item.leaveBlank
                            && data.field.key
                            && ![
                                'no',
                                'waktu_pembelian',
                                'total_rp',
                                'diskon_rp',
                                'total_net_rp',
                                'action'
                            ].includes(data.field.key)
                        ">
                            <vue-select
                                v-if="data.field.key == 'jenis_pembayaran'"
                                :options="listMetodePembayaran"
                                v-model="selectedMetodePembayaran"
                                class="custom-v-select w-95 mt-2"
                            >
                            </vue-select>
                            <b-input v-else size="sm" class="mt-2 w-95" @input="searchValueChanged($event, data.field.key)" />
                        </template>
                        <div class="text-wrap text-break" v-else>
                            <template v-if="data.value && data.field.substr && data.field.substr != undefined">
                                <p class="text-truncate d-inline-block w-100 pr-2 m-0" v-if="data.value.length > (data.field.substr / 7.5)" v-tooltip="data.value">
                                    {{ data.value.substring(0, (data.field.substr / 7.5)) + '...' }}
                                </p>
                                <p class="m-0" v-else>{{ data.value || '-' }}</p>
                            </template>
                            <template v-else-if="data.item.leaveBlank">{{ data.value }}</template>
                            <template v-else>{{ data.value || '-' }}</template>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <div v-if="!data.item.leaveBlank">
                            <b-button
                                variant="primary" size="sm"
                                class="text-capitalize"
                                @click="detailPembayaran(data.item.id)">
                                lihat struk
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </DataTableWrapper>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import debounce from 'lodash/debounce';
import startCase from 'lodash/startCase';
import { mapGetters } from 'vuex';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import { ThousandSeparator } from '../../helpers/global'

locale.use(lang);

export default {
    components: {
        'vue-select': () => import('vue-select'),
        DataTableWrapper: () => import('../../components/DataTableWrapper2'),
        DatePickerX: () => import('v-calendar/lib/components/date-picker.umd'),
    },
    data() {
        return {
            sortBy: '',
            sortDesc: false,
            currentPage: 1,
            perPage: 10,
            customEntryOptions: [5],
            periodeSelected: 'hari ini',
            dateRange: null,
            totalPembeliValue: null,
            totalPembeliAllValue: null,
            totalPendapatanValue: null,
            searchValue: [],
            dataList: [],
            fromPage: 0,
            toPage: 0,
            rows: 0,
            totalEntries: 0,
            waktuKonsultasi: '',
            tanggalLahir: '',
            allowSearch: [
                'waktu_pembelian'
            ],
            listMetodePembayaran: ['TUNAI', 'TRANSFER', 'QRIS'],
            selectedMetodePembayaran: null,
        };
    },
    computed: {
        ...mapGetters(['getKlinikId', 'getRolesName', 'klinikUser']),
        minDate() {
            return moment().subtract(3, 'months').toDate();
        },
        maxDate() {
            return moment().toDate()
        },
        selectedPeriodeRange() {
            const {
                periodeSelected
            } = this;
            return /(pilih)/gi.test(periodeSelected);
        },
        filterPeriode() {
            return (
                ['hari ini', 'minggu ini', 'bulan ini', 'pilih tanggal'] |> (x => x.map(item => ({
                    value: item,
                    text: startCase(item)
                })))
            );
        },
        fieldList() {
            const fields = [{
                    key: 'no',
                    thStyle: 'min-width: 50px',
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'waktu_pembelian',
                    label: 'waktu pembelian',
                    thStyle: 'min-width: 175px',
                    sortable: true,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'nama_layanan',
                    label: 'nama obat & bhp',
                    thStyle: 'min-width: 175px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 200,
                },
                {
                    key: 'quantity_layanan',
                    label: 'jumlah',
                    thStyle: 'min-width: 150px',
                    sortable: false,
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle',
                    substr: 125,
                },
                {
                    key: 'price_layanan',
                    label: 'biaya',
                    thStyle: 'min-width: 175px',
                    sortable: false,
                    thClass: 'text-center align-middle',
                    substr: 125,
                },
                {
                    key: 'total_rp',
                    label: 'total biaya',
                    thStyle: 'min-width: 175px',
                    sortable: true,
                    tdClass: 'text-right',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'diskon_rp',
                    label: 'Diskon',
                    thStyle: 'min-width: 150px',
                    sortable: true,
                    tdClass: 'text-right',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'total_net_rp',
                    label: 'total yang harus dibayar',
                    thStyle: 'min-width: 175px',
                    sortable: true,
                    tdClass: 'text-right',
                    thClass: 'text-center align-middle',
                    substr: 100,
                },
                {
                    key: 'jenis_pembayaran',
                    label: 'metode pembayaran',
                    thStyle: 'min-width: 192px;',
                    sortable: true,
                    tdClass: 'text-left',
                    thClass: 'text-center align-middle',
                },
                {
                    key: 'actions',
                    stickyColumn: true,
                    isRowHeader: true,
                    sortable: false,
                    thStyle: 'min-width: 135px',
                    tdClass: 'text-center',
                    thClass: 'text-center align-middle th-actions',
                }
            ];
            return fields;
        },
    },
    watch: {
        sortBy() {
            this.fetchData();
        },
        sortDesc() {
            this.fetchData();
        },
        searchValue: {
            handler: 'fetchData',
            deep: true
        },
        periodeSelected(val) {
            if (val !== 'pilih tanggal') {
                this.fetchData();
            } else {
                this.dateRange = null;
            }
        },
        dateRange: {
            handler: function (val) {
                if (this.periodeSelected === 'pilih tanggal') {
                    this.fetchData();
                }
            },
            deep: true
        },
        selectedMetodePembayaran: {
            handler: function (val) {
                this.fetchData();
            },
            deep: true
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        thousandSeparator(num, withRp) {
            return ThousandSeparator(num, withRp)
        },
        disabledDate(val) {
            const monthsBefore = moment(val).diff(moment(), 'months', true);
            return !(
                moment(val).diff(moment(), 'months', true) |> (x => x < 1 && x >= -3.0 && moment(val).isSameOrBefore(moment()))
            );
        },
        searchValueChanged: debounce(function (val, key) {
            const {
                searchValue
            } = this;
            const z = searchValue.filter(item => item.key !== key);
            this.searchValue = [
                ...z,
                {
                    key,
                    value: val
                }
            ];
        }, 500),
        periodeX({
            periode = null,
            rawValue = false
        } = {}) {
            const formatBackendDate = 'YYYY-MM-DD';
            const rawValueFormat = 'DD-MMM-YYYY';
            switch (periode && periode.toLowerCase()) {
                case 'pilih tanggal':
                    const {
                        dateRange
                    } = this;
                    if (dateRange) {
                        const { start: startDate, end: endDate } = dateRange;
                        const formatDate = 'DD-MM-YYYY';
                        if (rawValue) {
                            return `${moment(startDate, formatDate).format(rawValueFormat)} - ${moment(endDate, formatDate).format(rawValueFormat)}`;
                        } else {
                            return `&from=${moment(startDate, formatDate).format(
                                formatBackendDate
                            )}&to=${moment(endDate, formatDate).format(formatBackendDate)}`;
                        }
                    } else {
                        return null;
                    }

                case 'hari ini':
                    const today = moment().format(formatBackendDate);
                    return rawValue ?
                        moment().format(rawValueFormat) :
                        Array(2)
                            .fill(today)
                            .map(
                                (val, index) =>
                                    `&${(item => (item ? 'to' : 'from'))(index)}=${val}`
                            )
                            .join('');

                case 'minggu ini':
                    const startWeek = moment().startOf('isoWeek');
                    const endWeek = moment().endOf('isoWeek');
                    return rawValue ?
                        `${startWeek.format(rawValueFormat)}-${endWeek.format(
                            rawValueFormat
                        )}` :
                        `&from=${startWeek.format(formatBackendDate)}&to=${endWeek.format(
                            formatBackendDate
                        )}`;

                case 'bulan ini':
                    const startMonth = moment().startOf('month');
                    const endMonth = moment().endOf('month');
                    return rawValue ?
                        `${startMonth.format(rawValueFormat)}-${endMonth.format(
                            rawValueFormat
                        )}` :
                        `&from=${startMonth.format(
                            formatBackendDate
                        )}&to=${endMonth.format(formatBackendDate)}`;

                default:
                    break;
            }
        },
        handleValueChanged({ perPage, currentPage }) {
            if (this.perPage) this.perPage = perPage;
            if (this.perPage) this.currentPage = currentPage;
            this.fetchData();
        },
        onSearch(val) {
            if (!val) return;
            this.search(val, this);
        },
        determineParameter() {
            const {
                periodeX,
                periodeSelected: periode,
                sortBy,
                sortDesc,
                searchValue,
                selectedMetodePembayaran,
            } = this;

            let tmp = '';
            tmp += `${periodeX({ periode })}`;
            searchValue.map(item => {
                let x = item.key;
                tmp += `&${x}=${item.value}`;
            });

            if (selectedMetodePembayaran) {
                tmp = `&jenis_pembayaran=${selectedMetodePembayaran}${tmp}`;
            }
            if (sortBy) {
                let column = sortBy
                tmp += `&column=${column}&order=${sortDesc ? 'desc' : 'asc'}`;
            }

            return tmp;
        },
        async fetchData() {
            try {
                const {
                    determineParameter
                } = this;
                const res = await this.$axios.get(
                    `penjualan?klinik_id=${this.getKlinikId}&is_penjualan=true&limit=${this.perPage}&page=${this.currentPage
                    }${determineParameter()}`
                );

                const {
                    status: success,
                    data,
                    meta
                } = res.data;

                if (success) {
                    let {
                        data: listLaporanPendapatan,
                        total: totalEntries,
                        to: toPage,
                        from: fromPage
                    } = data;

                    const copyObj = Object.assign({}, listLaporanPendapatan[0]);
                    const tmp = Object.keys(copyObj).map(item => {
                        copyObj[item] = null;
                    });
                    const tmpList = [
                        ...listLaporanPendapatan.map((item, index) => ({
                            ...item,
                            no: (this.currentPage - 1) * this.perPage + index + 1
                        }))
                    ];

                    this.dataList = (tmpList &&
                        tmpList.length > 0 && [
                            Object.assign(copyObj, {
                                leaveBlank: true
                            }),
                            ...tmpList
                        ]) || [...tmpList, {
                            leaveBlank: true
                        }];

                    this.totalPembeliValue = meta.total_pembeli;
                    this.totalPembeliAllValue = meta.total_pembeli_all;
                    this.totalPendapatanValue = meta.total_pendapatan;
                    this.rows = totalEntries;
                    this.totalEntries = totalEntries;
                    this.toPage = toPage || 0;
                    this.fromPage = fromPage || 0;
                    return this;
                }
            } catch (err) {
                // console.log(err);
            }
        },
        async download() {
            try {
                const res = await this.$axios.get(`penjualan/download?${this.determineParameter()}&klinik_id=${this.getKlinikId}&is_penjualan=true`);
                window.open(res.data.data.link, '_blank');
            } catch (err) {
                // console.log(err);
            }
        },
        detailPembayaran(id) {
            window.open(window.location.origin + `/klinik/penjualan/struk/${id}`);
        },
    }
};
</script>
  
<style lang="scss">
$baseBgColor: #e6e6e6;
$evenBgColor: #f9f9f9;

.laporan-pendapatan-wrapper {
    $border-radius: 12px;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
    background-color: $baseBgColor;
    color: #4c6e8a !important;

    section {
        table {
            thead {
                tr {
                    th {
                        background-color: transparent !important;
                        color: #4c6e8a !important;
                        border: none !important;
                    }
                }
            }

            tbody {
                tr {
                    &:nth-child(even) {
                        background-color: #f9f9f9;
                    }
                }
            }
        }
    }

    .el-range-separator {
        width: 35px;
    }
}

.custom-v-select {
    .vs__dropdown-toggle {
        max-height: 29.94px;
        background-color: #fff;
        overflow: hidden;
    }

    .vs__dropdown-menu {
        width: auto !important;
    }
}

@media screen and (min-width: 993px) {
    .text-right-lg {
        text-align: right;
    }
}

/* width */
#laporan-penjualan-table::-webkit-scrollbar {
    width: 5px;
}

/* Track */
#laporan-penjualan-table::-webkit-scrollbar-track {
    box-shadow: inset 0 0 1px grey;
    border-radius: 10px;
}

/* Handle */
#laporan-penjualan-table::-webkit-scrollbar-thumb {
    background: #cdcdcd;
    border-radius: 10px;
}

/* Handle on hover */
#laporan-penjualan-table::-webkit-scrollbar-thumb:hover {
    background: #cdcdcd;
}

@media only screen and (max-width: 1550px) and (min-width: 1280px) {
    body {
        overflow-x: hidden;
    }

    ::-webkit-scrollbar {
        width: initial;
    }

    #laporan-penjualan-table {
        max-width: 100% !important;
    }
}

@media screen and (min-width: 1300px) {
    body {
        overflow-x: visible;
    }

    body::-webkit-scrollbar-track {
        box-shadow: inset 0 0 1px grey;
        border-radius: 10px;
    }

    body::-webkit-scrollbar-thumb {
        background: #cdcdcd;
        border-radius: 10px;
    }

    #laporan-penjualan-table {
        max-width: 100% !important;
    }

    ul {
        margin: 0;
    }

    ul.dashed {
        list-style-type: none;
    }

    ul.dashed>li {
        text-indent: -5px;
    }

    ul.dashed>li:before {
        content: "-";
        text-indent: -5px;
    }
    ul.hide-li {
        list-style: none;
    }
}
.tooltip .tooltip-inner {
    max-width: 500px !important;
    width: 300px !important;
}
</style>

<style>
    .th-actions {
        position: sticky;
        right: 0; 
        z-index: 5;
    }
    #laporan-penjualan-table tbody tr th {
        position: sticky;
        right: 0; 
        z-index: 5;
        background-color: white;
    }
    #laporan-penjualan-wrapper .table-responsive {
        min-height: 210px !important;
    }
    .table.b-table > thead > tr > th.b-table-sticky-header {
        position: sticky !important;
    }
    .table.b-table > tbody > tr > td.b-table-sticky-column {
        position: sticky !important;
    }
    .sorticon [aria-sort] {
        background-position: right calc(0.75rem / 2) top 35px !important;
        padding-right: calc( 0.75rem + 0.65em ) !important;
    }
</style>
  